import { Component, Output, EventEmitter, Input } from "@angular/core";
import { CoreService } from "src/app/services/core.service";
import { MatDialog } from "@angular/material/dialog";
import { navItems } from "../../vertical/sidebar/sidebar-data";
import { TranslateService } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { BrandingComponent } from "../../vertical/sidebar/branding.component";
import { AppSettings } from "src/app/config";
import { FormsModule } from "@angular/forms";
import { SessionService } from "src/app/services/session.service";

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: "app-horizontal-header",
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent],
  templateUrl: "./header.component.html",
})
export class AppHorizontalHeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  @Output() optionsChange = new EventEmitter<AppSettings>();

  public selectedLanguage: any = {
    language: "English",
    code: "en",
    type: "US",
    icon: "/assets/images/flag/icon-flag-en.svg",
  };

  public languages: any[] = [
    {
      language: "English",
      code: "en",
      type: "US",
      icon: "/assets/images/flag/icon-flag-en.svg",
    },
    {
      language: "Español",
      code: "es",
      icon: "/assets/images/flag/icon-flag-es.svg",
    },
    {
      language: "Français",
      code: "fr",
      icon: "/assets/images/flag/icon-flag-fr.svg",
    },
    {
      language: "German",
      code: "de",
      icon: "/assets/images/flag/icon-flag-de.svg",
    },
  ];
  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private sessionService: SessionService
  ) {
    translate.setDefaultLang("en");
  }

  async logOut() {
    await this.sessionService.signOutUser();
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {});
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  notifications: notifications[] = [
    {
      id: 1,
      img: "/assets/images/profile/user-1.jpg",
      title: "Roman Joined the Team!",
      subtitle: "Congratulate him",
    },
    {
      id: 2,
      img: "/assets/images/profile/user-2.jpg",
      title: "New message received",
      subtitle: "Salma sent you new message",
    },
    {
      id: 3,
      img: "/assets/images/profile/user-3.jpg",
      title: "New Payment received",
      subtitle: "Check your earnings",
    },
    {
      id: 4,
      img: "/assets/images/profile/user-4.jpg",
      title: "Jolly completed tasks",
      subtitle: "Assign her new tasks",
    },
    {
      id: 5,
      img: "/assets/images/profile/user-5.jpg",
      title: "Roman Joined the Team!",
      subtitle: "Congratulate him",
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: "/assets/images/svgs/icon-account.svg",
      title: "My Profile",
      subtitle: "Account Settings",
      link: "/",
    },
    {
      id: 2,
      img: "/assets/images/svgs/icon-inbox.svg",
      title: "My Inbox",
      subtitle: "Messages & Email",
      link: "/",
    },
    {
      id: 3,
      img: "/assets/images/svgs/icon-tasks.svg",
      title: "My Tasks",
      subtitle: "To-do and Daily Tasks",
      link: "/",
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      img: "/assets/images/svgs/icon-dd-chat.svg",
      title: "Chat Application",
      subtitle: "Messages & Emails",
      link: "/",
    },
    {
      id: 2,
      img: "/assets/images/svgs/icon-dd-cart.svg",
      title: "eCommerce App",
      subtitle: "Buy a Product",
      link: "/",
    },
    {
      id: 3,
      img: "/assets/images/svgs/icon-dd-invoice.svg",
      title: "Invoice App",
      subtitle: "Get latest invoice",
      link: "/",
    },
    {
      id: 4,
      img: "/assets/images/svgs/icon-dd-date.svg",
      title: "Calendar App",
      subtitle: "Get Dates",
      link: "/",
    },
    {
      id: 5,
      img: "/assets/images/svgs/icon-dd-mobile.svg",
      title: "Contact Application",
      subtitle: "2 Unsaved Contacts",
      link: "/",
    },
    {
      id: 6,
      img: "/assets/images/svgs/icon-dd-lifebuoy.svg",
      title: "Tickets App",
      subtitle: "Create new ticket",
      link: "/",
    },
    {
      id: 7,
      img: "/assets/images/svgs/icon-dd-message-box.svg",
      title: "Email App",
      subtitle: "Get new emails",
      link: "/",
    },
    {
      id: 8,
      img: "/assets/images/svgs/icon-dd-application.svg",
      title: "Courses",
      subtitle: "Create new course",
      link: "/",
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: "Pricing Page",
      link: "/",
    },
    {
      id: 2,
      title: "Authentication Design",
      link: "/",
    },
    {
      id: 3,
      title: "Register Now",
      link: "/",
    },
    {
      id: 4,
      title: "404 Error Page",
      link: "/",
    },
    {
      id: 5,
      title: "Notes App",
      link: "/",
    },
    {
      id: 6,
      title: "Store App",
      link: "/",
    },
    {
      id: 7,
      title: "Todo Application",
      link: "/",
    },
    {
      id: 8,
      title: "Treeview",
      link: "/",
    },
  ];
}

@Component({
  selector: "app-search-dialog",
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: "search-dialog.component.html",
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = "";
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
